import Server from "src/server";
import Util from "src/util/util";
import { EventBus } from "src/eventBus";

export default
{
  namespaced: true,
  state:
    {
      isLoading: false,
      nodeTypes: [],
      copiedNodes: [],
    },

  mutations:
    {

    },

  actions:
    {
      reset(context)
      {
        context.state.nodeTypes = [];
      },

      async setNodeTypes(context) {
        try {
            context.state.isLoading = true;
            var result = await Server.get("getNodeList").promise;
            context.state.isLoading = false;
            if(!result.data.success)
                throw(result.data.error);
        
            context.state.nodeTypes = result.data.nodeList;
            return result;
        }
        catch(e) {
            console.log("Failed 'getNodeList' server call. " + e.toString());
            context.state.isLoading = false;
            return {data:{success: false, error: e}};
        }
      },

      async insertNode(context, {node}) {
        try {
          var result = await Server.post("insertNode", {node: node}).promise;
          if(!result.data.success)
            throw(result.data.error);
          
          var plural = context.getters.getPlural(node.type);
          let inserted = result.data.node;
          let workflow = context.rootState.wfStore.workflow;
          workflow[plural].push(inserted);

          // add current user as last edited user and save asynchronously
          workflow.lastEditedUser = context.rootState.userStore.user.username;
          Server.post("updateWorkflow", {workflow: workflow});

          return result;
        }
        catch(e) {
          console.log("Failed 'insertNode' server call. " + e.toString());
          return {data:{success: false, error: e}};
        }
      },

      async updateNode(context, {node}) {
        try {
          var result = await Server.post("updateNode", {node: node}).promise;
          if(!result.data.success)
            throw(result.data.error);

          var plural = context.getters.getPlural(node.type);
          let updated = result.data.node;
          let workflow = context.rootState.wfStore.workflow;
          workflow[plural] = Util.replaceInArray(workflow[plural], "_id", updated);

          // add current user as last edited user and save asynchronously
          workflow.lastEditedUser = context.rootState.userStore.user.username;
          Server.post("updateWorkflow", {workflow: workflow});

          return result;
        }
        catch(e) {
          console.log("Failed 'updateNode' server call. " + e.toString());
          return {data:{success: false, error: e}};
        }
      },

      async deleteNode(context, {node}) {
        try {
          var result = await Server.post("deleteNode", {node:node}).promise;
          if(!result.data.success)
            throw(result.data.error);

          var plural = context.getters.getPlural(node.type);
          let workflow = context.rootState.wfStore.workflow;
          workflow[plural] = Util.removeFromArrayByKey(workflow[plural], "_id", node.object._id);
          updateAttachedNodes(context, workflow, node.object);
          updateLogNodes(workflow, node.object);
          var date = new Date();
          return result;
        }
        catch(e) {
          console.log("Failed 'deleteNode' server call. " + e.toString());
          return {data:{success: false, error: e}};
        }
      },

      async copyNodes(context, {nodes}) {
        context.state.copiedNodes = nodes;
      },

      async pasteNodes(context, {workflow}) {
        try {
          var result = await Server.post("pasteNodes", {workflow: workflow, nodes: context.state.copiedNodes}).promise;
          if(!result.data.success)
            throw(result.data.error);

          context.rootState.wfStore.workflow = result.data.workflow;
          return result;
        }
        catch(e) {
          console.log("Failed 'pasteNodes' server call. " + e.toString());
          return {data:{success: false, error: e}};
        }
      },

      async deleteNodes(context, {workflow, nodes}) {
        try {
          var result = await Server.post("deleteNodes", {workflow: workflow, nodes: nodes}).promise;
          if(!result.data.success)
            throw(result.data.error);

          context.rootState.wfStore.workflow = result.data.workflow;
          return result;
        }
        catch(e) {
          console.log("Failed 'deleteNodes' server call. " + e.toString());
          return {data:{success: false, error: e}};
        }
      },

    },

  getters:
    {
        getColor: (state) => (type) =>  {
            var node = state.nodeTypes.find(a => a.type == type);
            if(node)
                return node.color;
        },

        getPlural: (state) => (type) =>  {
            var node = state.nodeTypes.find(a => a.type == type);
            if(node)
                return node.plural;
        },

        getPrefix: (state) => (type) =>  {
            var node = state.nodeTypes.find(a => a.type == type);
            if(node)
                return node.prefix;
        },

        isInput: (state) => (type) =>  {
            var node = state.nodeTypes.find(a => a.type == type);
            if(node)
                return !!node.input;
        },

        getInputTypes: (state) => {
          var types = state.nodeTypes.filter(a => a.input == true);
          return types;
        },

        isOutput: (state) => (type) =>  {
          var node = state.nodeTypes.find(a => a.type == type);
          if(node)
              return !!node.output;
        },

        getOutputTypes: (state) => {
          var types = state.nodeTypes.filter(a => a.output == true);
          return types;
        },

        getInputAndOutputTypes: (state) => {
          var types = state.nodeTypes.filter(a => a.input == true || a.output == true);
          return types;
        },

        isSatellite: (state) => (type) =>  {
          var node = state.nodeTypes.find(a => a.type == type);
          if(node)
              return !!node.satellite;
        },
    },
};


// helper function to update attached src and/or dest nodes after a node is deleted 
function updateAttachedNodes(context, workflow, object) {

  // src
  if(object.src) {
    for(var i = 0; i < object.src.length; i++) {
      var src = object.src[i];
      if(src.type == "startNode"){
        var srcObj = workflow[src.type]
      } else {
        var plural = context.getters["getPlural"](src.type);
        var srcObj = workflow[plural].find(a => a._id == src._id);
      }
      if(srcObj) {
        if(src.type == "switch") {
          var exists = srcObj.cases.find((agCase) => agCase.dest && agCase.dest._id == object._id);
          if(exists)
            exists.dest = null;
        }
        else if (src.type == "splitNode"){
          var exists = srcObj.paths.find((agPath) => agPath.dest && agPath.dest._id == object._id);
          if(exists)
            exists.dest = null;
        }
        else {
          srcObj.dest = {};
        }
      }
    }
  }

  // dest
  if(object.dest) {
    var plural = context.getters["getPlural"](object.dest.type);
    let dest = workflow[plural].find(a => a._id == object.dest._id);
    if(dest) {
      dest.src = Util.removeFromArrayByKey(dest.src, "_id", object._id);
    }
  }


  // (switches' cases)
  if(object.cases) {
    for(let i = 0; i < object.cases.length; i++) {
      let agCase = object.cases[i];
      if(agCase.dest) {
        var plural = context.getters["getPlural"](agCase.dest.type);
        let dest = workflow[plural].find(a => a._id == agCase.dest._id);
        if(dest) {
          dest.src = Util.removeFromArrayByKey(dest.src, "_id", object._id);
        }
      }
    }
  }
  // (splitNode's paths)
  if(object.paths) {
    for(let i = 0; i < object.paths.length; i++) {
      let agPath = object.paths[i];
      if(agPath.dest) {
        var plural = context.getters["getPlural"](agPath.dest.type);
        let dest = workflow[plural].find(a => a._id == agPath.dest._id);
        if(dest) {
          dest.src = Util.removeFromArrayByKey(dest.src, "_id", object._id);
        }
      }
    }
  }
}

// helper function to remove object from any logNodes that had it selected
function updateLogNodes(workflow, object) {
  var logNodes = workflow.logNodes.filter(a => a.logObjects && a.logObjects.indexOf(object.shortname) > -1);
  for(var i = 0; i < logNodes.length; i++) {
    var logNode = logNodes[i];
    logNode.logObjects.splice(logNode.logObjects.indexOf(object.shortname), 1);
  }
}



// WEBPACK FOOTER //
// ./src/store/node.js